import { Chip, ChipOwnProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeliveryImage from '../../assets/images/3d-icons/delivery.png';
import { getDeliveryTimeLetterLabel } from '../utils/common.utils';

export interface DeliveryTimeChipProps {
  deliveryTime: number;
  color?: ChipOwnProps['color'];
  variant?: ChipOwnProps['variant'];
}

export default function DeliveryTimeChip({ deliveryTime, variant = 'tag', color }: DeliveryTimeChipProps): React.JSX.Element {
  const { t } = useTranslation(['settings']);

  return (
    <Chip
      variant={variant}
      color={color}
      label={t('settings:delivery_time_type', { to: getDeliveryTimeLetterLabel(deliveryTime) })}
      icon={<img src={DeliveryImage} height="20" width="20" />}
    />
  );
}
